function sortByAlphabeticalOrder(a: any, b: any,keyName?:string): number {
  const key = keyName ?? 'label'
  if (a?.[key]?.toLowerCase?.() < b?.[key]?.toLowerCase?.()) {
    return -1;
  }
  if (a?.[key]?.toLowerCase?.() > b?.[key]?.toLowerCase?.()) {
    return 1;
  }
  return 0;
}

const suggestiveInputHelpers = {
  sortByAlphabeticalOrder,
};

export default suggestiveInputHelpers;
